/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import Slider from "./components/Slider/Slider";
import { showSlider } from './scripts/scripts';


class Home extends Component {
    constructor() {
        super();
        this.state = {
            width:  0,
        };
    }
    componentDidMount(){
        showSlider();
    }
    render() {
            return (
                <div id="mainSlider">
                    <Slider/>
                </div>
            );
    }
}

export default Home;
